var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showComp)?_c('div',{class:[
    'motorway-valuation-wrapper',
    { 'motorway-valuation-wrapper--last': _vm.isLast },
  ]},[_c('current-vehicle-valuation',{attrs:{"header":_vm.valuationHeader,"subheader":_vm.valuationSubHeader,"guidePriceText":_vm.guidePriceText,"disclaimerText":_vm.disclaimerText}}),_c('motorway-component',{attrs:{"header":_vm.motorwayHeader,"subheader":_vm.motorwaySubHeader,"benefits":_vm.benefits,"motorwayBenefitsHeader":_vm.benefitsHeader,"buttonText":_vm.buttonText,"isLast":_vm.isLast,"link":_vm.link}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }